module.exports = __webpack_public_path__ + "static/media/Rakata_Normal.5cd3606c.png";